import { render, staticRenderFns } from "./VeJwJingsaiProjectStatisticsList.vue?vue&type=template&id=d09d04d4&scoped=true"
import script from "./VeJwJingsaiProjectStatisticsList.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiProjectStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./VeJwJingsaiProjectStatisticsList.vue?vue&type=style&index=0&id=d09d04d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09d04d4",
  null
  
)

export default component.exports